/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { Mutation, Query } from 'components/common/Query';
import {
  DISMISS_REVIEW_REPORTS_MUTATION,
  RESOLVE_REVIEW_REPORTS_MUTATION,
} from 'components/ReviewReport/mutations';
import ReviewReportDetails from './Details';

/**
 * Query to fetch a review report from api.
 */
export const REVIEW_REPORT_QUERY = gql`
  query ReviewReportDetails($id: ID!) {
    reviewReport(id: $id) {
      id
      reason
      comment
      status
      createdOn
      updatedOn
      reviewedOn
      reporter {
        id
        fullname
      }
      reviewer {
        id
        fullname
      }
      reviewee {
        id
        fullname
      }
      reviewedBy {
        id
        fullname
      }
      review {
        id
        rate
        comment
        status
        createdOn
        updatedOn
        reviewedOn
        reviewedBy {
          id
          fullname
        }
        reviewer {
          id
          fullname
        }
        reviewee {
          id
          fullname
        }
      }
    }
  }
`;

class ReviewReportDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      showNotification: false,
    };
    this.Compose = adopt({
      mutateResolveReviewReports: this.resolveReviewReports,
      mutateDismissReviewReports: this.dismissReviewReports,
      query: this.reviewReport,
    });
    this.fetchMore = () => {};
  }

  reviewReport = ({ render }) => {
    const { id } = this.props;
    return (
      <Query
        query={REVIEW_REPORT_QUERY}
        variables={{ id }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMore = fetchMore;
          return render({ data, loading, fetchMore });
        }}
      </Query>
    );
  };

  resolveReviewReports = ({ render }) => (
    <Mutation
      mutation={RESOLVE_REVIEW_REPORTS_MUTATION}
      onCompleted={this.mutationCompleted('resolveReviewReports')}
    >
      {(handleResolveReviewReports, { loading }) =>
        render({ handleResolveReviewReports, loadingResolve: loading })
      }
    </Mutation>
  );

  dismissReviewReports = ({ render }) => (
    <Mutation
      mutation={DISMISS_REVIEW_REPORTS_MUTATION}
      onCompleted={this.mutationCompleted('dismissReviewReports')}
    >
      {(handleDismissReviewReports, { loading }) =>
        render({ handleDismissReviewReports, loadingDismiss: loading })
      }
    </Mutation>
  );

  mutationCompleted = field => data => {
    const { id } = this.props;
    const payload = data[field] || {};
    const successIds = payload.successIds || [];
    const succeeded =
      successIds.indexOf(id) !== -1 || successIds.indexOf(`${id}`) !== -1;
    if (!succeeded || (payload.errors && payload.errors.length > 0)) {
      this.setState({
        errors: payload.errors || [],
        showNotification: true,
      });
    } else {
      this.setState({
        errors: [],
        showNotification: false,
      });
    }
    this.handleRefresh();
  };

  handleRefresh = () => {
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  handleCloseNotification = () => {
    this.setState({ errors: [], showNotification: false });
  };

  render() {
    const { errors, showNotification } = this.state;
    return (
      <this.Compose>
        {({
          mutateResolveReviewReports: {
            handleResolveReviewReports,
            loadingResolve,
          },
          mutateDismissReviewReports: {
            handleDismissReviewReports,
            loadingDismiss,
          },
          query: { data, loading },
        }) => (
          <ReviewReportDetails
            data={data && data.reviewReport ? data.reviewReport : {}}
            loading={loading || Object.keys(data).length === 0}
            resolveReport={items =>
              handleResolveReviewReports({ variables: { ids: items } })
            }
            dismissReport={items =>
              handleDismissReviewReports({ variables: { ids: items } })
            }
            actionLoading={loadingResolve || loadingDismiss}
            refresh={this.handleRefresh}
            errors={errors}
            showNotification={showNotification}
            closeNotification={this.handleCloseNotification}
          />
        )}
      </this.Compose>
    );
  }
}

ReviewReportDetailsContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ReviewReportDetailsContainer;
